<template>
  <v-tour
    name="portal-guide"
    :steps="steps"
    :options="myOptions"
    :callbacks="myCallbacks"
  >
    <template slot-scope="tour">
      <transition name="fade">
        <div
          class="invoice-guide-container tour-container"
          v-if="firstTourStatus"
        >
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <div slot="actions" class="v-actions text-align-center">
              <button
                @click="tour.previousStep"
                v-if="!tour.isFirst"
                class="btn btn-light btn-sm"
              >
                {{ tour.labels.buttonPrevious }}
              </button>
              <button
                @click="tour.nextStep"
                v-if="!tour.isLast"
                class="btn btn-primary btn-sm"
              >
                {{
                  tour.isFirst
                    ? $t(`dummyInvoice.buttons.stop`)
                    : tour.labels.buttonNext
                }}
              </button>
              <button
                @click="onFinish"
                v-if="tour.isLast"
                class="btn btn-primary btn-sm"
              >
                {{ tour.labels.buttonStop }}
              </button>
            </div>
          </v-step>
        </div>
      </transition>
    </template>
  </v-tour>
</template>

<script>
import { mapState } from 'vuex'
// import { ACTIONS, ENTITIES } from '@/utils/constants'
export default {
  name: 'portal-guide',
  data() {
    return {
      myOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonPrevious: this.$t(`dummyInvoice.buttons.previous`),
          buttonNext: this.$t(`dummyInvoice.buttons.next`),
          buttonStop: this.$t(`dummyInvoice.buttons.stop`)
        }
      },
      myCallbacks: {
        onPreviousStep: this.onPreviousStep,
        onNextStep: this.onNextStep,
        onFinish: this.onFinish
      },
      message: null,
      step: 0,
      copied: false,
      steps: [
        {
          target: '#v-step-11',
          content: `Welcome to Drip Capital's customer portal.<br/>Click here anytime to get help`,
          params: {
            placement: 'bottom'
          },
          offset: -100
        },
        {
          target: '#v-step-12',
          content: `Check your available total facility size here`,
          params: {
            placement: 'right'
          },
          offset: -100
        },
        {
          target: '#v-step-13',
          content: `Get started by submitting your 1st invoice for financing`,
          params: {
            placement: 'bottom'
          },
          offset: -100
        }
      ]
    }
  },
  props: ['firstTourStatus'],
  mounted() {
    if (!this.hasPermission) {
      this.steps = [
        {
          target: '#v-step-11',
          content: `Welcome to Drip Capital's customer portal.<br/>Click here anytime to get help`,
          params: {
            placement: 'bottom'
          },
          offset: -100
        },
        {
          target: '#v-step-12',
          content: `Check your available total facility size here`,
          params: {
            placement: 'right'
          },
          offset: -100
        }
      ]
    }
  },
  methods: {
    onNextStep() {
      this.$store.dispatch('setTourState', true)
      this.activeTour === 3
        ? this.$emit('enableAddInvoiceChanged', false)
        : this.$emit('enableAddInvoiceChanged', true)
    },
    onPreviousStep() {
      this.$store.dispatch('setTourState', false)
    },
    onFinish() {
      this.$emit('enableAddInvoiceChanged', false)
      this.$emit('firstTourStatusChanged', false)
      this.$tours['portal-guide'].stop()
      this.$store.dispatch('resetTourState', false)
    }
  },
  computed: {
    hasPermission() {
      return this.$store.getters.hasInvoiceAddAndCreatePermission()
      /**
       * ?: below code is the old access roles code
        return (
          this.$store.getters.hasPermission('esign') ||
          this.$store.getters.hasPermission('edit')
        )
       **/
    },
    ...mapState({
      activeTour: (state) => state.root.activeTour
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables';
.invoice-guide-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
